/** `state, country` for the selection row; drops blank/whitespace parts so a missing one leaves no dangling comma. */
export const formatLocation = (...parts: (string | null | undefined)[]): string =>
  parts
    .map(part => part?.trim() ?? '')
    .filter(Boolean)
    .join(', ');
